<script setup lang="ts">
import { unknownImageUrl, noImageLogoUrl } from '@/constants';
import { copyToClipboard } from '@/helpers/copyToClipboard';
import { TagDetails } from '@/types';
import { computed } from 'vue';

const props = defineProps<{
  textToCopy?: string;
  images?: (string | undefined | null)[];
  imagesSize?: string | number;
  label?: string;
  hideLabel?: boolean;
  badgeImage?: string;
  badgeImageSize?: string | number;
  tags?: TagDetails[];
}>();

const formattedImages = computed(() =>
  props.images?.map((i) => (i === null ? null : i || unknownImageUrl)),
);

function onLabelClick() {
  const textToCopy = props.textToCopy;
  if (!textToCopy) return;
  copyToClipboard(textToCopy);
}
</script>

<template>
  <div class="d-flex text-no-wrap align-center">
    <div v-if="formattedImages">
      <v-avatar
        v-for="(image, index) in formattedImages"
        :key="index"
        :size="imagesSize || 24"
        :class="{ 'ml-n2': index > 0 }"
        :style="{ 'z-index': 1 + index }"
      >
        <v-img v-if="image" :src="image" alt="asset logo">
          <template v-slot:error>
            <v-img :src="noImageLogoUrl"></v-img>
          </template>
        </v-img>
      </v-avatar>
    </div>
    <v-avatar
      v-if="badgeImage"
      :size="badgeImageSize || 14"
      class="ml-n2 mt-n4"
      :style="{ 'z-index': 1 + (formattedImages?.length || 0) }"
    >
      <v-img :src="badgeImage" />
    </v-avatar>
    <span
      v-if="!hideLabel"
      class="ml-2 text-truncate"
      style="max-width: 145px"
      :style="{ cursor: textToCopy ? 'pointer' : 'inherit' }"
      :title="textToCopy ? textToCopy : undefined"
      @click="onLabelClick"
    >
      {{ label }}
    </span>
    <div class="ml-3" v-if="tags && tags.length > 0">
      <v-chip
        v-for="(tag, i) in tags"
        :key="i"
        label
        size="x-small"
        class="text-medium-emphasis mx-1"
      >
        <v-icon v-if="tag.icon" size="x-small" :icon="tag.icon" class="mr-1" />
        {{ tag.text }}
      </v-chip>
    </div>
  </div>
</template>
